import React, { FunctionComponent } from 'react'
import {
  Header as BrHeader,
  Button,
  ContextBar,
  Logo,
} from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Logout from '../IdentityBroker/Logout'
import ContactPageModal from '../../pages/ContactPageModal'
import { getActualPage } from '../../services/redux/features/custom.redux'
import './style.scss'
import { getBrandName, isAudi, isVWFS } from '../../config'

const Header: FunctionComponent = () => {
  const [showContact, setShowContact] = React.useState(false)
  const { t } = useTranslation()

  const landingPageUrl = process.env.REACT_APP_LANDING_PAGE_URL
  return (
    <>
      <BrHeader
        testId="appHeader"
        staticHeader
        logo={
          <Logo
            alt={t('app:header.logo.altText')}
            ariaLabel={t('app:header.logo.ariaLabel')}
            href={landingPageUrl}
            height="65px"
            heightSmall="45px"
            testId={`appHeaderLogo-${getBrandName()}`}
            {...(isAudi() ? { custom: true } : {})}
            {...(isAudi() ? { src: '/images/logo_audiondemand.svg' } : {})}
          />
        }
      >
        <ContextBar isContextBar>
          {isVWFS() && (
            <ContextBar.SiteNav>
              <ContextBar.SiteNav.Item>
                <Logo
                  alt={t('app:header.logo.altText')}
                  ariaLabel={t('app:header.logo.ariaLabel')}
                  custom
                  src="/images/logo-rentACar.svg"
                  disableLink
                />
              </ContextBar.SiteNav.Item>
            </ContextBar.SiteNav>
          )}
          <ContextBar.SiteNav>
            <ContextBar.SiteNav.Item>
              <Logout />
              <Button
                link
                simple
                ariaLabel={t('contact:ariaLabelTitle')}
                onClick={() => setShowContact(true)}
                icon="semantic-mail"
              >
                <span>{t('contact:labelTitle')}</span>
              </Button>
            </ContextBar.SiteNav.Item>
          </ContextBar.SiteNav>
        </ContextBar>
      </BrHeader>

      <ContactPageModal
        testId="appContactPageModal"
        visible={showContact}
        onClose={() => setShowContact(false)}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    actualPage: getActualPage(state),
  }
}

export default connect(mapStateToProps, {})(Header)
